module.exports = __webpack_public_path__ + "img/centra.2d0f26bd.jpg";